import { Component } from '@angular/core'
import { OrderConfirmationItemsComponent } from '@spartacus/order/components'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'app-custom-order-confirmation-items',
    templateUrl: './custom-order-confirmation-items.component.html',
    styleUrls: ['./custom-order-confirmation-items.component.scss'],
    standalone: false
})
export class CustomOrderConfirmationItemsComponent extends OrderConfirmationItemsComponent {
  constructor(protected orderFacade: OrderFacade) {
    super(orderFacade)
  }
}
